<template>
  <div class="instructional-video">
    <div class="main" @click.stop="playVideo()">
      <img class="button" :src="require('@/assets/img/play.svg')">
      <BaseText3 text="How<br>to play"/>
    </div>
    <BaseVideo
      class="preview"
      ref="preview"
      :url="media === 'Mobile' ? require('@/assets/vid/instructions-loop-mobile.mp4') : require('@/assets/vid/instructions-loop-desktop.mp4')"
      :autoplay="true"
      :muted="true"
      :loop="true"
    />
    <transition name="fade">
      <BaseVideo
        class="video"
        ref="video"
        v-show="isPlaying"
        :url="media === 'Mobile' ? require('@/assets/vid/instructions-mobile.mp4') : require('@/assets/vid/instructions-desktop.mp4')"
        @ended="onVideoEnded()"
      />
    </transition>
  </div>
</template>

<script>
import BaseVideo from '@/components/BaseVideo/BaseVideo'
import BaseText3 from '@/components/BaseText3/BaseText3'
import getMediaOnLoad from '@/mixins/getMediaOnLoad'
export default {
  mixins: [ getMediaOnLoad ],
  components: {
    BaseVideo,
    BaseText3
  },
  mounted () {
    this.loadVideos()
  },
  data () {
    return {
      isPlaying: false
    }
  },
  beforeDestroy () {
    this.$store.commit('ui/setBackgroundMusicState', true)
  },
  methods: {
    async loadVideos () {
      await Promise.all([
        this.$refs['preview'].loaded,
        this.$refs['video'].loaded
      ])
      this.$emit('loaded')
    },
    playVideo () {
      this.$store.commit('ui/setBackgroundMusicState', false)
      this.$refs['video'].$el.play()
      this.$refs['video'].$el.currentTime = 0
      this.isPlaying = true
    },
    onVideoEnded () {
      this.$store.commit('ui/setBackgroundMusicState', true)
      this.isPlaying = false
    },
    stopVideo () {
      this.$refs['video'].$el.pause()
      this.$refs['video'].$el.currentTime = 0
      this.onVideoEnded()
    }
  }
}
</script>

<style lang="scss" scoped>
.instructional-video {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.preview,
.video {
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  pointer-events: none;
  display: block;
  @media #{$media-3} {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
  }
}
.main {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.preview {
  z-index: -1;
}
.button {
  width: 3rem;
  margin-bottom: 2rem;
}
.base-text-3 {
  font-size: 3.5rem;
  line-height: 3rem;
}
</style>
